import { userConstants } from '../Constants';
import { userService } from '../../services';

let user = userService.getUser();
const initialState = user ? { loggingIn: false, loggedIn: false, user } : {
  loggedIn: false, loggingIn: false, user: ''
};

const updateObject = (oldObject, updatedValues) => {
  return {
      ...oldObject,
      ...updatedValues
  }
};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return updateObject(state, {
        loggingIn: true,
        loggedIn: false,
        user: action.user
      });
    case userConstants.LOGIN_SUCCESS:
      return updateObject(state, {
        loggedIn: true,
        loggingIn: false,
        user: action.user
      });
    case userConstants.LOGIN_FAILURE:
      return updateObject(state, {loggedIn: false, loggingIn: false, user: ''});
    case userConstants.LOGOUT:
      return updateObject(state, {loggedIn: false, loggingIn: false, user: ''});
    default:
      return state
  }
}